import { render } from "./Audio.vue?vue&type=template&id=836ae0bc&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"

import "./Audio.vue?vue&type=style&index=0&id=836ae0bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-836ae0bc"

export default script